<template>
  <v-card>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12>
          <v-select
            :items="layouts"
            v-bind:value="activePlaylist.events[index].layout_id"
            @change="updateEvent($event, index, 'layout_id')"
            item-text="name"
            item-value="id"
            label="Layout"
            outline
            single-line
            hide-details
          ></v-select>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            v-bind:value="activePlaylist.events[index].repeat"
            @change="updateEvent(parseInt($event), index, 'repeat')"
            label="Repeat"
            type="number"
            min="0"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            v-bind:value="activePlaylist.events[index].duration"
            @input="updateEvent(parseInt($event), index, 'duration')"
            label="Duration"
            type="number"
            min="0"
            required
          ></v-text-field>
        </v-flex>
        <v-flex
          v-if="index === length - 1"
          xs4
        >
          <v-checkbox
            label="Loop to start"
            :value="activePlaylist.events[index].loop_start"
            :input-value="activePlaylist.events[index].loop_start"
            :false-value="0"
            :true-value="1"
            @change="updateEvent($event, index, 'loop_start')"
          ></v-checkbox>
        </v-flex>
        <v-flex
          xs6
        >
          <v-combobox
            v-mask="'##:##'"
            :value="activePlaylist.events[index].start_time"
            prepend-icon="timer"
            :items="times"
            label="Start time"
            required
            @input="updateEvent($event, index, 'start_time')"
          ></v-combobox>
        </v-flex>
        <v-flex
          xs6
        >
          <v-combobox
            v-mask="'##:##'"
            :value="activePlaylist.events[index].end_time"
            prepend-icon="timer_off"
            :items="times"
            label="End time"
            required
            @input="updateEvent($event, index, 'end_time')"
          ></v-combobox>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import { mask } from 'vue-the-mask';

export default {
  directives: { mask },
  props: {
    index: {
      type: Number,
      required: true,
    },
    length: {
      type: Number,
      required: true,
    },
  },
  computed: {
    activePlaylist: {
      get() {
        return this.$store.getters.getActivePlaylist;
      },
    },
    layouts: {
      get() {
        return this.$store.getters.getLayouts;
      },
    },
  },
  data() {
    return {
      times: [
        '00:00', '00:30',
        '01:00', '01:30',
        '02:00', '02:30',
        '03:00', '03:30',
        '04:00', '04:30',
        '05:00', '05:30',
        '06:00', '06:30',
        '07:00', '07:30',
        '08:00', '08:30',
        '09:00', '09:30',
        '10:00', '10:30',
        '11:00', '11:30',
        '12:00', '12:30',
        '13:00', '13:30',
        '14:00', '14:30',
        '15:00', '15:30',
        '16:00', '16:30',
        '17:00', '17:30',
        '18:00', '18:30',
        '19:00', '19:30',
        '20:00', '20:30',
        '21:00', '21:30',
        '22:00', '22:30',
        '23:00', '23:30',
      ],
    };
  },
  methods: {
    updateEvent(value, index, key) {
      const payload = {
        data: [
          {
            index,
            key,
            value,
          },
        ],
      };

      this.$store.dispatch('UPDATE_EVENT', payload);
    },
  },
};
</script>

<style scoped>

</style>
